import { Button, Card, Divider, Form, FormField, Header, Image, Message } from "semantic-ui-react"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import InfoIcon from "../../../images/info-Icon.svg"
import store from "../../../shared_component/utils/configureStore"
import { NUMERIC_REGEX } from "../../../shared_component/utils/stringHelpers"
import { updateInfo } from "../../../v1/actions/user"
import Notifications from "../../../v1/components/Notifications"
import { routerPaths } from "../../../v1/constants/paths"

const formatPhoneNumber = (value) => {
  if (!value) return value
  const phoneNumber = value.replace(/[^\d]/g, "")
  const phoneNumberLength = phoneNumber.length
  if (phoneNumberLength < 4) return phoneNumber
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`
}

const UpdateUser = ({ t, user, history, location }) => {
  const [mobileNumber, setMobileNumber] = useState("")
  const [firstName, setFirstName] = useState(user.firstName || "")
  const [lastName, setLastName] = useState("")
  const [mobileNumberError, setMobileNumberError] = useState("")
  const [firstNameError, setFirstNameError] = useState("")
  const [lastNameError, setLastNameError] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const maintenanceService = new URLSearchParams(location.search).get("maintenance_service")
  const diagnosisService = new URLSearchParams(location.search).get("diagnosis_service")

  useEffect(() => {
    if (user?.cellPhone) {
      setMobileNumber(formatPhoneNumber(user.cellPhone) || "")
    }
    if (user?.lastName) {
      setLastName(user.lastName || "")
    }
  }, [user])

  const handleMobileNumberChange = (e) => {
    const formattedPhoneNumber = formatPhoneNumber(e.target.value)
    setMobileNumber(formattedPhoneNumber)
    const phoneNumber = formattedPhoneNumber.replace(/[^\d]/g, "")
    if (phoneNumber.length === 10) {
      setMobileNumberError("")
    } else {
      setMobileNumberError(t("phoneFormatError"))
    }
  }

  const handleLastNameChange = (e) => {
    const regex = /^[a-zA-Z0-9'-]+$/
    const lastName = e.target.value
    const validLastName = regex.test(lastName)
    setLastName(e.target.value)
    setLastNameError(lastName.length > 0 && validLastName ? "" : t("lastNameValidationError"))
  }

  const handleFirstNameChange = (e) => {
    const regex = /^[a-zA-Z0-9'-]+$/
    const firstName = e.target.value
    const validFirstName = regex.test(firstName)
    setFirstName(e.target.value)
    setFirstNameError(firstName.length > 0 && validFirstName ? "" : t("firstNameValidationError"))
  }

  const handleSubmit = async () => {
    setIsSubmitting(true)
    let success = await store.dispatch(
      updateInfo({
        cellPhone: mobileNumber.replace(/[^\d]/g, ""),
        lastName: lastName
      })
    )
    if (!success) {
      store.dispatch(
        Notifications.error({
          title: t("errorLbl"),
          message: "Something went wrong",
          position: "tr",
          autoDismiss: 5,
          action: {
            label: "Dismiss"
          }
        })
      )
    } else {
      if (maintenanceService || diagnosisService) {
        history.replace({
          pathname: routerPaths.reviewServices,
          search: location.search
        })
      } else {
        history.push({
          pathname: routerPaths.selectVehicle
        })
      }
    }
    setIsSubmitting(false)
  }

  return (
    <Card className="update-user-card" raised={true}>
      <Card className="update-user-content">
        <div>
          <Card fluid className="update-user-info">
            <Image src={InfoIcon} />
            {t("enterYourPhone")}
          </Card>

          <Form>
            <FormField error={firstNameError.length > 0}>
              <label>
                {t("firstNameLbl")} <span style={{ color: "red" }}> *</span>
              </label>
              <input
                placeholder={t("firstNamePlaceHolder")}
                value={firstName}
                onChange={handleFirstNameChange}
              />
              {firstNameError && (
                <Message size="mini" negative>
                  {firstNameError}
                </Message>
              )}
            </FormField>
            <FormField error={lastNameError.length > 0}>
              <label>
                {t("lastNameLbl")} <span style={{ color: "red" }}> *</span>
              </label>
              <input
                placeholder={t("lastNamePlaceHolder")}
                value={lastName}
                onChange={handleLastNameChange}
              />
              {lastNameError && (
                <Message size="mini" negative>
                  {lastNameError}
                </Message>
              )}
            </FormField>
            <Divider />
            <FormField error={mobileNumberError.length > 0}>
              <label>
                {t("mobilePhoneNumberLbl")} <span style={{ color: "red" }}> *</span>
              </label>
              <input
                maxLength={14}
                placeholder={t("mobileNumberPlaceHolder")}
                value={mobileNumber}
                onChange={handleMobileNumberChange}
              />
              {mobileNumberError && (
                <Message size="mini" negative>
                  {mobileNumberError}
                </Message>
              )}
            </FormField>
          </Form>
        </div>
        <div className="action-button">
          <Button
            fluid
            onClick={handleSubmit}
            loading={isSubmitting}
            disabled={
              !mobileNumber ||
              !!mobileNumberError ||
              !firstName ||
              !!firstNameError ||
              !lastName ||
              !!lastNameError ||
              isSubmitting
            }
            className="primary-button"
          >
            {t("saveAndContinue")}
          </Button>
        </div>
      </Card>
    </Card>
  )
}

function mapStateToProps(state) {
  let user = state.user || {}

  return {
    user: user
  }
}

export default connect(mapStateToProps)(withTranslation("userInfoPanel")(UpdateUser))
